import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";

import brtIcon from "assets/img/report-brt.png";

const headerStyles = StyleSheet.create({
    header: {
        position: 'absolute',
        fontFamily: 'Roboto',
        top: 20,
        left: 20,
        right: 20,
        height: 65,
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: '#E6E6E6',
    },
    headerLeft: {
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    headerLeftTitle: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontWeight: 600,
        fontSize: 16,
        color: '#333333',
    },
    headerLeftSubTitle: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: 14,
        color: '#636363',
        marginTop: 15,
    },
    headerRight: {
        position: 'absolute',
        top: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
    },
    headerRightImageContainer: {
        position: 'relative',
        width: 130,
        height: 23.57,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    headerRightImage: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: 100,
        height: 23.57,
    },
    headerRightContainer: {
        position: 'relative',
        width: 130,
        display: 'flex',
        flexDirection: 'row',
        marginTop: 12.43,
    },
    headerRightTitle: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: 12,
        color: '#636363',
    },
    headerRightValue: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: 12,
        color: '#333333',
    },
});

type ReportPDFPageHeaderProps = {
    organizationName: string;
    reportPeriod: string;
};

const ReportPDFPageHeader = ({ organizationName, reportPeriod }: ReportPDFPageHeaderProps) => {
    return (
        <View style={headerStyles.header} fixed>
            <View style={headerStyles.headerLeft}>
                <Text style={headerStyles.headerLeftTitle}>USAGE REPORT</Text>
                <Text style={headerStyles.headerLeftSubTitle}>{organizationName}</Text>
            </View>
            <View style={headerStyles.headerRight}>
                <View style={headerStyles.headerRightImageContainer}>
                    <Image
                        style={headerStyles.headerRightImage}
                        src={brtIcon}
                    />
                </View>
                <View style={headerStyles.headerRightContainer}>
                    <Text style={headerStyles.headerRightTitle}>Report period:&nbsp;</Text>
                    <Text style={headerStyles.headerRightValue}>{reportPeriod}</Text>
                </View>
            </View>
        </View>
    );
};

export default ReportPDFPageHeader;
